import { createSelector } from 'reselect';

import { NewnityEntityType, NLocation } from '../types';
import { getDataStore } from './genericSelectors';

export const selectLocations = (state: any) =>
  getDataStore(state)[NewnityEntityType.NLocation];

export const selectLocationItems = createSelector(
  [selectLocations],
  locations => {
    return Object.keys(locations.items).filter((key: string) => key !== '0').map<NLocation>(
      key => locations.items[Number(key)]
    ).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  }
);

export const selectLocationById = (state: any, locationId: number) => selectLocations(state).items[locationId];
